import { render, staticRenderFns } from "./UpdateFarmModal.vue?vue&type=template&id=65c1cc19"
import script from "./UpdateFarmModal.vue?vue&type=script&lang=js"
export * from "./UpdateFarmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports